import { useEffect } from 'react';
import { getUTCDateFormatyyyyMMdd } from '../utils/date/date';

export const useDateTimer = (dates: string[], onExpiry: () => void) => {
  useEffect(() => {
    const now = Date.now();
    const todayUTC = getUTCDateFormatyyyyMMdd();

    // This finds the first date that expires today (UTC) and is still in the future.
    const nextExpiryToday = dates.find(dateString => {
      const dateTime = new Date(dateString).getTime();
      const isInFuture = dateTime > now;
      const dateUTC = getUTCDateFormatyyyyMMdd(dateString);
      const isToday = dateUTC === todayUTC;
      return isInFuture && isToday;
    });

    if (!nextExpiryToday) return;

    const timeUntilExpiry = new Date(nextExpiryToday).getTime() - now;
    const timer = setTimeout(onExpiry, timeUntilExpiry);
    return () => clearTimeout(timer);
  }, [dates, onExpiry]);
};
